import axios from 'axios';




export default (url, type = false) => axios.get(url, type);


// export default async function get(url, type = false, ourRequestToken = null) {

//     return await axios.get(
//         url,
//         type
//     );
// }
